import React from 'react'

import Text from '@components/kit/text'
import { Row } from '@components/kit/grid'

import {
  ColumnWrapper,
  HorizontalRule,
  LabelText,
  RowWrapper,
  ValueText
} from '@components/table'
import { GLP1PrescriberInfo } from '@store/HealthTracking/types'

interface PrescriberInfoProps {
  prescriber: GLP1PrescriberInfo | null
}

const PrescriberInfo = ({ prescriber }: PrescriberInfoProps) => {
  return (
    <>
      <RowWrapper>
        <LabelText font='display.14.bold'>Prescriber Information</LabelText>
      </RowWrapper>

      {prescriber ? (
        <>
          <Row width='100%'>
            <ColumnWrapper width='70%'>
              <LabelText>Prescriber Name</LabelText>
              <ValueText>{prescriber.prescriber_name}</ValueText>
            </ColumnWrapper>
            <ColumnWrapper width='30%'>
              <LabelText>Phone</LabelText>
              <ValueText>{prescriber.phone}</ValueText>
            </ColumnWrapper>
          </Row>
          <Row>
            <ColumnWrapper>
              <LabelText>Street Address</LabelText>
              <ValueText>{prescriber.line}</ValueText>
            </ColumnWrapper>
          </Row>
          <Row flexWrap='wrap'>
            <ColumnWrapper width='40%'>
              <LabelText>City</LabelText>
              <ValueText>{prescriber.city}</ValueText>
            </ColumnWrapper>
            <ColumnWrapper width='30%'>
              <LabelText>State</LabelText>
              <ValueText>{prescriber.state}</ValueText>
            </ColumnWrapper>
            <ColumnWrapper width='30%'>
              <LabelText>Zipcode</LabelText>
              <ValueText>{prescriber.zipcode}</ValueText>
            </ColumnWrapper>
          </Row>
        </>
      ) : (
        <RowWrapper>
          <Text font='display.14.bold' textColor='newMutedPurple'>
            The member has not filled in the prescriber information yet.
          </Text>
        </RowWrapper>
      )}

      <HorizontalRule />
    </>
  )
}

export default PrescriberInfo
